import { render, staticRenderFns } from "./ModulesListDataTable.vue?vue&type=template&id=17772dee"
import script from "./ModulesListDataTable.vue?vue&type=script&lang=js"
export * from "./ModulesListDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports